import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import {
    getTickerOrIsin,
    getAssetNameByType,
} from '@alfa-bank/site-invest-emitents-common/helpers';

import type { TIssuerInfoSearchCell } from './models';

export const IssuerInfoSearchCell: FC<TIssuerInfoSearchCell> = ({
    AnalyticsEventSender,
    Grid,
    Link,
    Logo,
    Text,
    analytics,
    asset,
    styles,
}) => {
    const { assetType, issuer } = asset;

    const assetName = getAssetNameByType(assetType.code, asset);
    const tickerOrIsin = getTickerOrIsin(asset);

    return (
        <AnalyticsEventSender
            $events={{
                onClick: {
                    data: { ...analytics?.suggestionsItemCLick, ['label_detail']: assetName },
                },
            }}
        >
            <Link
                className={cn(styles.external, styles.asset)}
                href={asset.linkPage}
                noUnderline
                styler={{ padding: 12 }}
                target="_blank"
            >
                <Grid columnsMargin={16} columnsWidth={[40, null]} justify="start">
                    <Logo assetName={assetName} issuer={issuer} size={40} />
                    <>
                        <Text styler={{ marginTop: 0, marginBottom: 4 }} view="primary-small">
                            {assetName}
                        </Text>
                        <Text kind="caption" styler={{ margin: 0 }} view="secondary-medium">
                            {tickerOrIsin.toUpperCase()}
                        </Text>
                    </>
                </Grid>
            </Link>
        </AnalyticsEventSender>
    );
};
